<template>
	<div class="system">
		<div class="system__menus">
			<el-tree :data="menus" @node-click="handleNodeClick" :default-expand-all="true" :check-on-click-node="true">
				<div class="custom-tree-node" slot-scope="{ node,data }">
					<span :class="{'active':setActive(data)}">{{node.label}}</span>
				</div>
			</el-tree>
		</div>
		<div class="system__main">
			<template v-for="(item, key) in components_list">
				<component v-if="item == active" :index="key" :key="key" :is="item"></component>
			</template>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
	import {
		technology,
		imRoutes,
		chatManger,
		lineManger,
		wordsMange,
		fastWordsManage,
		miniProgram,
		websiteManager,
		wechartManager,
		weiboManager,
		customerField,
		communicationField,
		jdManager,
		telTechnology,
		telLineManger,
		telStatusSetting

	} from "./index";
	export default {
		components: {
			technology,
			lineManger,
			chatManger,
			wordsMange,
			fastWordsManage,
			miniProgram,
			websiteManager,
			wechartManager,
			weiboManager,
			customerField,
			communicationField,
			imRoutes,
			jdManager,
			telTechnology,
			telLineManger,
			telStatusSetting

		},
		computed: {
			...mapGetters([
				'lark_switch_url'
			])
		},
		data() {
			return {
				active: 'technology',
				menus: [
					{
						label: "IM模块设置",
						key: ['technology','imRoutes', 'lineManger','chatManger', 'wordsMange','fastWordsManage','miniProgram','websiteManager','wechartManager','weiboManager','jdManager'],
						children: [{
								label: "技能组设置",
								key: 'technology'
							},
							{
								label: "IM路由设置",
								key: 'imRoutes'
							},
							{
								label: "开闭线管理",
								key: 'lineManger'
							},{
							label: "聊天功能设置",
							key: 'chatManger'
						}, {
							label: "话术类型",
							key: 'wordsMange'
						}, {
							label: "快捷话术",
							key: 'fastWordsManage'
						}, 
						// {
						// 	label: "小程序卡片",
						// 	key: 'miniProgram'
						// }, 
						// {
						// 	label: "网站接入",
						// 	key: 'websiteManager'
						// }, 
						{
							label: "微信接入",
							key: 'wechartManager'
						}, 
						{
							label: "微博接入",
							key: 'weiboManager'
						}, 
						{
							label: "京东小程序接入",
							key: 'jdManager'
						}, 
						
						]
					},
					{
						label: "字段管理",
						key: ['customerField', 'communicationField'],
						children: [{
							label: "客户字段",
							key: 'customerField'
						},
							{
								label: "沟通小结字段",
								key: 'communicationField'
							}
						]
					}
				],
				components_list: ["technology", "lineManger", "chatManger", 'wordsMange', 'fastWordsManage', 'miniProgram',
					'websiteManager', 'wechartManager', 'weiboManager', 'customerField', 'communicationField','imRoutes','jdManager','telTechnology','telLineManger','telStatusSetting'
				]
			};
		},
		created() {
			if(this.lark_switch_url) {
				this.menus.splice(1, 0, {
					label: "电话模块",
					key: ['telTechnology', 'telLineManger','telStatusSetting'],
					children: [{
							label: "技能组设置",
							key: 'telTechnology'
						},
						{
							label: "开闭线管理",
							key: 'telLineManger'
						},
						{
							label:"电话状态设置",
							key:'telStatusSetting'
						}
					]
				})
			}
		},
		methods: {
			handleNodeClick(data) {
				if (!data.children) {
					this.active = data.key;
				}
			},
			setActive(data){
				if(this.isArray(data.key)){
					return data.key.includes(this.active)
				}
				return this.active == data.key
			},
			isArray(something){
			    return Object.prototype.toString.call(something) === '[object Array]';
			}
		}
	};
</script>
<style lang="scss">
	.system {
		height: calc(100vh - 94px);
		display: flex;

		&__menus {
			padding: 30px 20px;
			width: 209px;
			height: 100%;
			border: 1px solid #eaedf1;
			color: #3c4353;
			font-size: 12px;

			.el-tree-node__content {
				height: 36px;
			}

			.custom-tree-node {
				span {
					&.active {
						color: #337eff;
					}
				}
			}
		}

		&__main {
			width: calc(100% - 209px);
			height: 100%;
			padding: 20px;
			
		}
	}
</style>
